const customFallback = {
  we_apologize: 'We apologize, an error has occurred',
  help_our_budly_team: 'Help our team fix this error',
  report_the_error: 'Report the error',
}

export default customFallback
